import { Component } from "react";
import { withRouter } from "../../utils/common.utils";
import vendorService from "../../services/vendor.service";
import noDataFoundPage from "../../images/nodatafound.png";
import DefaultImage from "../../images/no_image.jpg";
import algoliasearch from "algoliasearch/lite";

const searchClient = algoliasearch(
  "J89FYK2680",
  "ad6f144fe0b845dc40ba7d4289b1ed3d"
);
const index = searchClient.initIndex("profiles");

class VendorSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchVendors: [],
    };
    console.log(this.props.router?.params?.searchTerm);
  }
  componentDidMount() {
    this.searchVendor(this.props.router?.params?.searchTerm);
  }
  searchVendor = (key) => {
    this.props.loaderChange(true);
    index
      .search(this.props.router?.params?.searchTerm)
      .then(({ hits }) => {
        let vendors = hits?.length ? hits : [];
        this.setState({ searchVendors: vendors });
        this.props.loaderChange(false);
        console.log(hits);
      })
      .catch((err) => {
        this.props.loaderChange(false);
        console.log(err);
      });
    // vendorService.searchVendors(key).then(
    //     res => {
    //         console.log("res - ", res)
    //         let vendors = res ? res : []
    //         this.setState({ searchVendors: vendors })
    //         this.props.loaderChange(false)
    //     }
    // ).catch(
    //     err => {
    //         console.log(err)
    //         this.props.loaderChange(false)
    //     }
    // )
  };
  toStore = (i) => {
    console.log(i);
    this.props.router.navigate(`/category/${i}`);
  };
  render() {
    return (
      <div className="">
        <section className="product-details">
          <div className="container">
            {this.state.searchVendors.length ? (
              <div className="row mt-5">
                {this.state.searchVendors.map((el, i) => {
                  return (
                    <div className="col-lg-2 col-md-4 col-6" key={i}>
                      <div
                        className="card card-width mb-lg-4 border-0"
                        onClick={() => {
                          this.toStore(el?.objectID);
                        }}
                      >
                        <img
                          src={el?.image ? el?.image : DefaultImage}
                          className="card-img-top"
                          alt="..."
                        />
                        <div className="card-body">
                          <span className="text-decoration-none" to="/category">
                            <h5 className="card-title vendor-name text-black">
                              {el?.name}
                            </h5>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="data-not-found search-data-not-found d-flex align-items-center justify-content-center">
                <div className="">
                  <img src={noDataFoundPage} className="w-50" />
                  <div className="data-not-found-content d-md-flex d-lg-flex justify-content-center">
                    <button
                      className="btn btn-orange rounded-pill ms-3"
                      onClick={() => {
                        this.props.router.navigate(`/`);
                      }}
                    >
                      Go to Homepage
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    );
  }
}
export default withRouter(VendorSearch);
